import React, { useEffect, useMemo, useRef } from 'react'
import { z } from 'zod'
import { useFormState } from './hooks/useFormState'
import { type FieldError } from 'react-hook-form'
import * as style from './index.module.css'

/**
 * simulation
 *
 * @todo {@link https://github.com/sozo-japan/corporate/issues/223 テーブルのcssと表示ロジックが汚いからリファクタリングをしたい}
 */
export const Simulation = () => {
  const { salarys, register, onSubmit, isError, errors } = useFormState()
  const salaryRef = useRef<HTMLHeadingElement>(null)

  const scrollToResult = () => {
    salaryRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  useEffect(() => {
    if (salarys.length > 0) {
      scrollToResult()
    }
  }, [salarys])

  return (
    <>
      <div className={style.simulation}>
        <div className={style.discription}>
          <p className={style.subTitle}>{'＼　想定給与がわかる！　／'}</p>
          <h2 className={style.title}>{'出向単価を入力してみましょう'}</h2>
          <div className={style.boderLine} />
        </div>
        <form onSubmit={onSubmit} className={style.form}>
          <div>
            <label htmlFor="calculationType" className={style.label}>
              {'計算区分'}
            </label>
            <div className={style.selectBoxForms}>
              <label className={style.selectBoxArea}>
                <input
                  className={style.selectBox}
                  type="radio"
                  value="monthlyIncome"
                  {...register('calculationType')}
                />
                <p className={style.selectBoxLabel}>{'月収'}</p>
              </label>
              <label className={style.selectBoxArea}>
                <input
                  className={style.selectBox}
                  type="radio"
                  value="annualIncome"
                  {...register('calculationType')}
                />
                <p className={style.selectBoxLabel}>{'年収'}</p>
              </label>
            </div>
          </div>
          <div>
            <label htmlFor="leaderProject" className={style.label}>
              {'リーダー案件'}
            </label>
            <div className={style.selectBoxForms}>
              <label className={style.selectBoxArea}>
                <input
                  className={style.selectBox}
                  type="radio"
                  value="inPlanning"
                  {...register('leaderProject')}
                />
                <p className={style.selectBoxLabel}>{'参画'}</p>
              </label>
              <label className={style.selectBoxArea}>
                <input
                  className={style.selectBox}
                  type="radio"
                  value="notParticipating"
                  {...register('leaderProject')}
                />
                <p className={style.selectBoxLabel}>{'未参画'}</p>
              </label>
            </div>
          </div>
          <div>
            <label htmlFor="clientBillingRate" className={style.label}>
              {'客先請求単価'}
            </label>
            <div className={style.clientBillingRateArea}>
              <input
                className={`${style.inputForm} ${
                  isError ? style.errorBorder : style.defaultBorder
                }`}
                type="number"
                {...register('clientBillingRate', { valueAsNumber: true })}
                min={55}
                max={200}
                placeholder="55〜200"
                aria-invalid={errors.clientBillingRate ? 'true' : 'false'}
                aria-describedby="clientBillingRateError"
              />
              <p className={style.clientBillingRateUnit}>万円</p>
            </div>
            <div className={style.errorTextArea}>
              {errors.clientBillingRate ? (
                <ErrorMassage type={errors.clientBillingRate.type} />
              ) : null}
            </div>
          </div>
          <button
            type="submit"
            disabled={isError}
            className={`${style.button} ${
              isError ? style.disabledButton : style.defaultButton
            }`}
          >
            {'給料シュミレーションする'}
          </button>
        </form>
      </div>
      {salarys.length > 0 ? (
        <>
          <h2 className={style.result} ref={salaryRef}>
            {'結果'}
          </h2>
          <div className={style.parent}>
            <div className={`${style.mainHead} ${style.div1}`}>
              1<span className={style.year}>年目</span>
            </div>
            <div className={`${style.mainHead} ${style.div2}`}>
              2<span className={style.year}>年目</span>
            </div>
            <div className={`${style.mainHead} ${style.div3}`}>
              3<span className={style.year}>年目</span>
            </div>
            <div className={`${style.mainHead} ${style.div4}`}>
              4<span className={style.year}>年目</span>
            </div>
            <div className={`${style.text} ${style.div5}`}>
              {`${salarys[0].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div6}`}>
              {`${salarys[1].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div7}`}>
              {`${salarys[2].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div8}`}>
              {`${salarys[3].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.subHead} ${style.div9}`}>
              5<span className={style.year}>年目</span>
            </div>
            <div className={`${style.subHead} ${style.div10}`}>
              6<span className={style.year}>年目</span>
            </div>
            <div className={`${style.subHead} ${style.div11}`}>
              7<span className={style.year}>年目</span>
            </div>
            <div className={`${style.subHead} ${style.div12}`}>
              8<span className={style.year}>年目</span>
            </div>
            <div className={`${style.subHead} ${style.div13}`}>
              9<span className={style.year}>年目</span>
            </div>
            <div className={`${style.subHead} ${style.div14}`}>
              10<span className={style.year}>年目</span>
            </div>
            <div className={`${style.text} ${style.div15}`}>
              {`${salarys[4].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div16}`}>
              {`${salarys[5].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div17}`}>
              {`${salarys[6].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div18}`}>
              {`${salarys[7].toLocaleString()}`}
              <span className={style.yen}>円</span>
            </div>
            <div className={`${style.text} ${style.div19}`}>{`-`}</div>
            <div className={`${style.text} ${style.div20}`}>{`-`}</div>
          </div>
          <br />
          <p className={style.subText}>
            1年目の表示金額のみ業界経験者の場合となっております。
          </p>
          <p className={style.subText}>
            業界未経験者の場合は別途ご相談ください。
          </p>
        </>
      ) : null}
    </>
  )
}

interface Props {
  readonly type: FieldError['type']
}

const ErrorMassage = ({ type }: Props) => {
  const message = useMemo(() => {
    if (type === z.ZodIssueCode.too_small)
      return '55万円以上で入力してください。'
    if (type === z.ZodIssueCode.too_big)
      return '200万円以下で入力してください。'
    return '客先請求単価を入力してください。'
  }, [type])

  return (
    <p id="clientBillingRateError" role="alert" className={style.errorText}>
      {message}
    </p>
  )
}
